<template>
    <div class="pa-4">
        <v-card class="mt-2 py-2">
            <v-toolbar flat>
                <v-toolbar-title>Tester Detail</v-toolbar-title>
                <v-divider class="mx-4" inset vertical />
                <v-spacer />
                <v-btn depressed color="green" class="d-inline ms-2 white--text" @click="export2xls">Export to XLS</v-btn>
            </v-toolbar>
            <div class="mt-3">
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Delivery Date</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-menu v-model="dateMenu" :close-on-content-click="true" :nudge-right="40" transition="scale-transition" offset-y min-width="auto">
                            <template v-slot:activator="{ on, attrs}">
                                <v-text-field v-model="date" prepend-inner-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" hide-details="auto" dense outlined class="compact-form"></v-text-field>
                            </template>
                            <v-date-picker v-model="date" @change="handelChangeDate"></v-date-picker>
                        </v-menu>
                    </v-col>
                    <v-col lg="2" md="3" sm="4" cols="4">Volume</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="bottles" item-value="code" item-text="description" v-model="selectedBottle" @change="handleChangeBottle" />
                    </v-col>
                </v-row>
                <v-row class="mx-5">
                    <v-col lg="2" md="3" sm="4" cols="4">Koordinator</v-col>
                    <v-col lg="2" md="3" sm="8" cols="8">
                        <v-select outlined dense hide-details="auto" :items="coordinators" item-value="code" item-text="name" v-model="selectedCoordinator" @change="handleChangeCoordinator" />
                    </v-col>
                </v-row>
                <v-row class="compact-form my-2 mx-1">
                    <v-col>
                        <v-card outlined>
                            <v-skeleton-loader v-if="isLoading"
                                v-bind="attrs"
                                type="table-tbody">
                            </v-skeleton-loader>
                            <v-simple-table v-else fixed-header height="400" ref="tabelExport">
                                <template v-slot:default class="spreadsheet-table">
                                    <thead>
                                        <tr>
                                            <th rowspan="2" class="header-cell text-center" style="width:10px;">No.</th>
                                            <th class="header-cell text-center" colspan="2">{{ selectedBottle }}ML</th>
                                            <th class="header-cell text-center">Ambil Stok Adelphi</th>
                                            <th class="header-cell text-center" rowspan="2">SISA</th>
                                            <th class="header-cell" :colspan="totalOutlet">{{ coordinatorName }}</th>
                                            <th class="header-cell text-center" rowspan="2">TOTAL</th>
                                        </tr>
                                        <tr>
                                            <th class="header-cell text-center" colspan="2">EXPIRED</th>
                                            <th class="header-cell text-center">{{ expiredDate }}</th>
                                            
                                            <template v-if="totalOutlet > 0">
                                                <th class="header-cell text-center text-no-wrap" v-for="(outlet, ido) in filteredOutlets" :key="ido">
                                                    {{ outlet.name }}
                                                </th>
                                            </template>
                                            <template v-else>
                                                <th class="header-cell text-center text-no-wrap">
                                                    
                                                </th>
                                            </template>

                                            
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(product, idp) in filteredProducts" :key="idp">
                                            <td>{{ idp + 1 }}</td>
                                            <td class="text-no-wrap">{{ product.code }}</td>
                                            <td class="text-no-wrap">{{ product.name }} ({{ product.size }}ML)</td>
                                            
                                            <td class="text-center">{{ getQtyFromAdelphiText(product) }}</td>
                                            <td class="text-center">{{ getQtySisaText(product) }}</td>
                                            
                                            <template v-if="totalOutlet > 0">
                                                <td class="text-center" v-for="(outlet, ido) in filteredOutlets" :key="ido">
                                                    {{ getQtyOutletText(product, outlet.code) }}
                                                </td>
                                            </template>
                                            <template v-else>
                                                <td class="text-center">
                                                </td>
                                            </template>

                                            <td class="text-center">{{ getQtyTotalText(product) }}</td>

                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th class="text-right" colspan="3">JUMLAH TOTAL</th>
                                            <th class="text-center">{{ getSumQtyFromAdelphiText() }}</th>
                                            <th class="text-center">{{ getSumQtySisaText() }}</th>
                                            
                                            <template v-if="totalOutlet > 0">
                                                <th class="text-center" v-for="(outlet, ido) in filteredOutlets" :key="ido">
                                                    {{ getSumQtyOutletText(outlet) }}
                                                </th>
                                            </template>
                                            <template v-else>
                                                <th class="text-center">
                                                </th>
                                            </template>
                                            

                                            <th class="text-center">{{ getSumQtyTotalText() }}</th>
                                        </tr>
                                    </tfoot>
                                </template>
                            </v-simple-table>
                        </v-card>
                    </v-col>
                </v-row>
            </div>
        </v-card>
    </div>
</template>

<script>
import moment from 'moment';
import { utils, writeFileXLSX } from 'xlsx';

export default {
    data() {
        return {
            date: '',
            expiredDate: '',
            dateMenu: false,
            isLoading: false,
            items: [],
            bottles: [],
            products: [],
            coordinators: [],
            outlets: [],
            selectedBottle: '250',
            selectedCoordinator: 'CRA',
            attrs: {
                class: 'mb-6',
                boilerplate: true,
                elevation: 2,
            },
            dow: 0,
        }
    },

    computed: {
        filteredProducts() {
            return this.products.filter( product => product.size === this.selectedBottle)
                .sort((a,b) => {
                    if (a.sort_no < b.sort_no) return -1;
                    if (a.sort_no > b.sort_no) return 1;
                    return 0;
                });
        },
        totalOutlet() {
            return this.filteredOutlets.length;
        },
        coordinatorName() {
            const coordinator = this.coordinators.find(i => i.code === this.selectedCoordinator);
            if (coordinator) {
                return coordinator.name;
            }

            return '';
        },
        filteredOutlets() {
            const outletCodes = [...new Set(this.items.map(item => item.outlet_code))];

            const outlets = this.outlets.filter(o => outletCodes.includes(o.code));

            return outlets.sort((a,b) => {
                if (a.name < b.name) return -1;
                if (a.name > b.name) return 1;
                return 0;
            });
        }
    },

    async created() {
        this.date = moment().format('YYYY-MM-DD');
        this.isLoading = true;
        this.getBottles();
        this.getCoordinators();
        this.getOutlets();
        this.getProducts();

        this.fetchData();
    },

    methods: {
        getBottles() {
            let dataMiscCodes = this.$store.state.misccode.objs;
            this.bottles = dataMiscCodes.filter((i => i.type.includes('Botol')))
                .sort((a,b) => {
                    return parseInt(a.code) - parseInt(b.code)
                });
        },
        async getCoordinators() {
            let response = await this.$store.dispatch('coordinator/getObjs');
            if (response.data.status == 'success') {
                this.coordinators = response.data.data;
            }
        },
        async getProducts() {
            let response = await this.$store.dispatch('variant/getObjs');
            if (response.data.status == 'success') {
                this.products = response.data.data;
                this.products = this.products.filter(p => p.is_active == 1)
                    .sort((a, b) => a.sort_no - b.sort_no);
            }
        },
        async getOutlets() {
            let response = await this.$store.dispatch('outlet/getObjs');
            if (response.data.status == 'success') {
                this.outlets = response.data.data;
            }
        },
        handelChangeDate() {
            this.fetchData();
        },
        handleChangeBottle() {
            this.fetchData();
        },
        handleChangeCoordinator() {
            this.fetchData();
        },
        getSumQtyOutlet(outlet) {
            let result = 0;
            if (this.filteredProducts) {
                result = this.items.filter(i => i.outlet_code == outlet.code)
                    .reduce((total, item) => total + Number(item.quantity), 0);
            }
            return result;
        },
        getSumQtyOutletText(outlet) {
            const result = this.getSumQtyOutlet(outlet);
            return result > 0 ? result : '';
        },
        getQtyOutletText(product, outletCode) {
            const result = this.getQtyOutlet(product, outletCode);
            return result > 0 ? result : '';
        },
        getQtyOutlet(product, outletCode) {
            const item = this.items.find(i => i.product_code == product.code && i.outlet_code == outletCode);
            if (item) {
                return item.quantity;
            } else {
                return 0;
            }
        },
        getSumQtyTotal() {
            let result = 0;
            if (this.filteredProducts) {
                result = this.filteredProducts.reduce((total, item) => total + this.getQtyTotal(item), 0);
            }
            return result;
        },
        getSumQtyTotalText() {
            const result = this.getSumQtyTotal();
            return result > 0 ? result : '';
        },
        getSumQtyFromAdelphi() {
            let result = 0;
            if (this.filteredProducts) {
                result = this.filteredProducts.reduce((total, item) => total + this.getQtyFromAdelphi(item), 0);
            }
            return result;
        },
        getSumQtyFromAdelphiText() {
            const result = this.getSumQtyFromAdelphi();
            return result > 0 ? result : '';
        },
        getQtyFromAdelphi(product) {
            const outletCodes = this.filteredOutlets.map(o => o.outlet_code);

            return this.items.filter(i => i.product_code == product.code && outletCodes.includes(i.outlet_code))
                .reduce((total, item) => total + Number(item.quantity_from_adelphi), 0);
        },
        getQtyFromAdelphiText(product) {
            const result = this.getQtyFromAdelphi(product);
            return result > 0 ? result : '';
        },
        getQtyTotal(product) {
            const outletCodes = this.filteredOutlets.map(o => o.outlet_code);

            return this.items.filter(i => i.product_code == product.code && outletCodes.includes(i.outlet_code))
                .reduce((total, item) => total + Number(item.quantity), 0);
        },
        getQtyTotalText(product) {
            const result = this.getQtyTotal(product);
            return result > 0 ? result : '';
        },
        getQtySisa(product) {
            return this.getQtyFromAdelphi(product) - this.getQtyTotal(product);
        },
        getQtySisaText(product) {
            const result = this.getQtyTotal(product);
            return result > 0 ? result : '';
        },
        getSumQtySisa() {
            let result = 0;
            if (this.filteredProducts) {
                result = this.filteredProducts.reduce((total, item) => total + this.getQtySisa(item), 0);
            }
            return result;
        },
        getSumQtySisaText() {
            const result = this.getSumQtySisa();
            return result > 0 ? result : '';
        },
        async fetchData() {
            this.isLoading = true;

            try {
                const response = (await this.$store.dispatch('tester/getReportTesterDetail', {
                    date: this.date,
                    size: this.selectedBottle,
                    coordinator: this.selectedCoordinator,
                }));

                const data = response.data.data;

                this.items = data.items;
                this.expiredDate = data.expired_date;
                this.dow = data.dow;
            } catch (error) {
                console.log('Error fetching tester detail:', error);
            } finally {
                this.isLoading = false;
            }
        },

        export2xls() {
            const wb = utils.table_to_book(this.$refs.tabelExport.$el.firstChild.firstChild);
            let fileName = 'Tester-Detail.xlsx';

            writeFileXLSX(wb, fileName);
        }
    }
}
</script>

<style scoped>
table, th, td {
  border: 1px solid grey;
  border-collapse: collapse;
}
#printresep th, td {
  padding: 10px;
  font-size: 12px;
}
.box {
    border:1px solid grey;
    height:30px;
    width:100px;    
}

.v-data-table table tfoot th
{
	position: sticky;
	bottom: 0;
	background: #FFF;
}
</style>